export default {
  namespaced: true,

  state: {
    isLoading: true,
    templateIsLoading: true,
    hasData: false,
    hasDetails: false,
    list: [],
    active: [],
    selected: [],
    templates: [],
    updateKey: 0,
    versions: [{"value": 'v1.18.15',"name": 'v1.18.15 (latest)'}, {"value": 'v1.17.15',"name": 'v1.17.15'}],
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    TEMPLATE_IS_LOADING(state, bool) {
      state.templateIsLoading = bool;
    },

    HAS_DATA(state, bool) {
      state.hasData = bool;
    },

    HAS_DETAILS(state, bool) {
      state.hasDetails = bool;
    },

    SET(state, services) {
      state.list = services;
    },

    SET_ACTIVE(state, services) {
      state.active = services;
    },

    SET_TEMPLATES(state, services) {
      state.templates = services;
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },

    UPDATE(state, resource) {
        const item = state.list.find(item => item.uuid === resource.uuid);
        Object.assign(item, resource);
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },
  },

  actions: {
    SET(context, services) {
      context.commit('SET', services);
    },

    SET_TEMPLATES(context, services) {
      context.commit('SET_TEMPLATES', services);
    },

    SET_SELECTED(context, resources) {
      context.commit('SET_SELECTED', resources);
    },
  }
}
